import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-register-of-fine',
  templateUrl: './register-of-fine.component.html',
  styleUrls: ['./register-of-fine.component.css']
})
export class RegisterOfFineComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
